import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { HamburgerSolidIcon } from '@compono/ui-icons';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';
import { IconButton } from '../IconButton/IconButton.js';
import 'react';
import { useLayoutScreenContext } from '../LayoutScreen/LayoutScreen/LayoutScreenContext.js';
import '../LayoutScreen/LayoutHeader/LayoutHeader.js';

var MobileHeader = function (_a) {
    var children = _a.children, _b = _a.hasSidebar, hasSidebar = _b === void 0 ? true : _b, props = __rest(_a, ["children", "hasSidebar"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var _c = useLayoutScreenContext({ optional: true }), header = _c.header, sidebar = _c.sidebar;
    var forwardProps = handleStyleProps(props, {
        themeKey: "mobileHeader",
    });
    return (jsxs(Box, __assign({}, forwardProps, { children: [hasSidebar && sidebar && header && (jsx(IconButton, __assign({ ref: header.sidebarToggleButtonRef, "data-nav-toggle": true, label: "Open or close the menu", onClick: sidebar.toggleIsOpen, rounded: true, size: "auto", look: "naked", tone: "inherit" }, { children: jsx(HamburgerSolidIcon, {}) }))), children] })));
};

export { MobileHeader };
//# sourceMappingURL=MobileHeader.js.map
